export type BillingMode = "subscription" | "one_time";

const rawBillingMode = (
  process.env.REACT_APP_READABLE_BILLING_MODE ?? "one_time"
)
  .trim()
  .toLowerCase();

export const BILLING_MODE: BillingMode =
  rawBillingMode === "subscription" ? "subscription" : "one_time";

export const BILLING_PORTAL_ENABLED = BILLING_MODE === "subscription";
export const PREMIUM_PRICE_CNY = 480;

// 月あたりの表示価格。年額を 12 で割り切れない設定は正しく表示できないので、
// 黙って丸めずにビルド／起動時点で落とす。
const premiumPricePerMonth = PREMIUM_PRICE_CNY / 12;
if (!Number.isInteger(premiumPricePerMonth)) {
  throw new Error(
    `PREMIUM_PRICE_CNY (${PREMIUM_PRICE_CNY}) is not divisible by 12; the monthly price cannot be displayed exactly`,
  );
}
export const PREMIUM_PRICE_CNY_PER_MONTH = premiumPricePerMonth;
export const PREMIUM_PLAN = BILLING_MODE === "one_time" ? "annual" : "yearly";
export const PREMIUM_HEADER_CTA =
  BILLING_MODE === "one_time"
    ? "注册专业会员（试用一周）"
    : "注册专业会员（免费试用一周）";
export const PREMIUM_HOME_CTA =
  BILLING_MODE === "one_time"
    ? `注册专业会员（试用一周）`
    : "注册专业会员（免费试用一周）";
export const PREMIUM_PURCHASING_BUTTON =
  BILLING_MODE === "one_time" ? "前往支付" : "填写付款方式";
export const PREMIUM_PROMO_TEXT =
  BILLING_MODE === "one_time"
    ? `${PREMIUM_PRICE_CNY} 元购买 1 年 Readable Pro，非自动续费。`
    : "首周免费试用，随后按年续费。";
// 特定商取引法に基づく表記（tokutei ページ）の利用料。
// 実際の課金額とページの表示がずれないよう、価格は必ず PREMIUM_PRICE_CNY から出す。
export const PREMIUM_PRICE_NOTICE_JA =
  BILLING_MODE === "one_time"
    ? `${PREMIUM_PRICE_CNY} 人民元（1 年分の買い切り。自動更新はありません。）`
    : `年額 ${PREMIUM_PRICE_CNY} 人民元（自動更新）`;
export const FREE_VERSION_PROMO_TEXT =
  BILLING_MODE === "one_time"
    ? "免费版就是试用版，可先体验后再决定。"
    : "可免费试用一周！";

export const normalizePaidPlan = (plan: string | null): string | null => {
  if (!plan) {
    return null;
  }

  if (BILLING_MODE === "one_time") {
    if (plan === "yearly") {
      return "annual";
    }

    return plan === "annual" ? "annual" : null;
  }

  return plan === "monthly" || plan === "yearly" ? plan : null;
};

export const isSupportedPaidPlan = (plan: string | null): boolean => {
  return normalizePaidPlan(plan) !== null;
};
